// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentCard_wrapper__Hx+Vj"};